export default [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../../views/Home.vue'),
    meta: {
      title: '首页',
      keepAlive: true,
    }

  },
  {
    path: '/texts',
    name: 'Texts',
    component: () => import('../../views/Texts.vue'),
    meta: {
      title: '绑定车牌号',
    }

  },

  {
    path: '/my',
    name: 'My',
    component: () => import('../../views/My/My.vue'),
    meta: {
      title: '我的',
      keepAlive: true,
    }
  },
  {
    path: '/regist',
    name: 'Regist',
    component: () => import('../../views/Login/Regist'),
    meta: {
      title: '注册',
      keepAlive: false,
    }
  },
  {
    path: '/mybonus',
    name: 'Mybonus',
    component: () => import('../../views/My/Filed/Mybonus.vue'),
    meta: {
      title: '我的积分',
      keepAlive: false,
    }
  },
  {
    path: '/mycoupon',
    name: 'Mycoupon',
    component: () => import('../../views/My/Filed/Mycoupon.vue'),
    meta: {
      title: '我的优惠券',
      keepAlive: false,
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/work.js